<template>
  <BaseCheckboxSelector
    v-if="categoriesMapped"
    allow-child-selection
    bordered
    color="primary"
    :items="categoriesMapped"
    :model-value="selectedCategories"
    @update:model-value="updateModelValue"
  >
    <template #header="{ toggle }">
      <slot
        name="header"
        :toggle="toggle"
      />
    </template>

    <template #footer>
      <slot name="footer" />
    </template>
  </BaseCheckboxSelector>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";
import type { Ref } from "vue";
import { computed } from "vue";

import { track } from "shared/boot/analytics";
import BaseCheckboxSelector from "shared/components/selectors/checkbox/BaseCheckboxSelector.vue";
import useSourceFilters from "shared/composables/useSourceFilters";
import useGlobalStore from "shared/stores/global";

interface Category {
  id: number;
  name: string;
}

const { categories }: { categories: Ref<Category[]> } =
  storeToRefs(useGlobalStore());

const { selectedCategories, addFilters } = useSourceFilters();

const categoriesMapped = computed<Category[]>(() =>
  categories.value.map((category) => ({
    id: category.id,
    name: category.name,
  }))
);

function updateModelValue(locationIds: number[]): void {
  addFilters("category", locationIds);
  track("Add category in Advanced Source Filter");
}
</script>
